export enum NeoRoundRule {
    None = 0,
    RoundTo99,
    RoundTo5,
}